import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'TN Covid Stats';
  state = 'Tamil Nadu';
  private sigma: any;
  private patientdata = [];
  private selectedPatient: any = {};
  total = 0;
  totalState: any;
  totalActive = 0;
  statelist: string[];
  constructor(private http: HttpClient) {}
  ngOnInit(){
    this.http.get('https://api.covid19india.org/state_district_wise.json').subscribe((res:any)=>{
      this.totalState =  res;
      this.statelist = Object.keys(this.totalState);
      console.log(this.statelist);
      
      this.formatState();
    });
  }
  formatState($event?) {
    console.log($event);
    if($event) this.state = $event;
    const res = [];
    this.total = 0;
    this.totalActive = 0;
    for (const key in this.totalState[this.state].districtData) {
      if (this.totalState[this.state].districtData.hasOwnProperty(key)) {
        this.totalState[this.state].districtData[key].district = key;
        this.total += this.totalState[this.state].districtData[key].confirmed;
        this.totalActive += this.totalState[this.state].districtData[key].active;
        res.push(this.totalState[this.state].districtData[key]);
      }
    }
    this.patientdata = JSON.parse(JSON.stringify(res.sort((a, b) => b.active - a.active)));
  }

}
